import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import { Dimmer } from "../../spinner";
import { Mensaje } from "../../mensajes2";
import useTable from "../../useTable";
import { formatMoneda } from "../../../util/varios";
import { ModalAgregarDeudaPublicidad } from "./modalAgregarDeudaPublicidad";
import { ModalAgregarDeudaLicores } from "./modalAgregarDeudaLicores";
import moment from "moment";
import Tablahtpp from "../propagandaypublicidad/tablaHistoryPP";
import TablaHistoricoLicores from "../impuestoLicores/tablaHistoricoLicores";

export const ModalGestionDeuda2 = (props) => {
    let op = require('../../../../src/modulos/datos');
    const token = JSON.parse(sessionStorage.getItem("jwtToken"));
    const [activate, setActivate] = useState(false);
    const [operacion, setOperacion] = useState(0);
    const [impuesto, setImpuesto] = useState(0.00);
    const [interes, setInteres] = useState();
    const [recargo, setRecargo] = useState();
    const [multa, setMulta] = useState();
    const [totDeuda, setTotDeuda] = useState();
    const [deuda, setDeuda] = useState([]);
    const [historico, setHistorico] = useState([]);
    const [show, setShow] = useState(false)
    const [show2, setShow2] = useState(false)
    const [deudaP, setDudaP] = useState();
    const [deudaL, setDeudaL] = useState();
    const [itemSelect, setItemSelect] = useState(-1);
    const [activo, setActivo] = useState(true);
    const [config, setConfig] = useState();
    const [mensaje, setMensaje] = useState({
        mostrar: false,
        titulo: "",
        texto: "",
        icono: "",
    });
    const [contribuyente, setContribuyente] = useState({
        idcontribuyente: "",
        nombre: "",
        ritm: "",
        rif: "",
        direccion: "",
        status: "",
    });
    const [filterFn, setFilterFn] = useState({
        fn: (items) => {
            return items;
        },
    });
    const [selected, setSelected] = useState([]);

    const headCells = props.tipo === "publicidad" ?
        [
            { id: '', label: 'AÑO', width: '10px', textAlign: "center", backgroundColor: 'rgba(5, 81, 130, 1)', fontSize: "10px", color: "white", disableSorting: true },
            { id: '', label: 'MES', width: '80px', textAlign: "center", backgroundColor: 'rgba(5, 81, 130, 1)', fontSize: "10px", color: "white", disableSorting: true },
            { id: '', label: 'DESCRIPCIÓN', width: '200px', textAlign: "center", backgroundColor: 'rgba(5, 81, 130, 1)', fontSize: "10px", color: "white", disableSorting: true },
            { id: '', label: 'MONTO', width: '80px', textAlign: "center", backgroundColor: 'rgba(5, 81, 130, 1)', fontSize: "10px", color: "white", disableSorting: true },
            { id: '', label: 'UBICACION', width: '150px', textAlign: "center", backgroundColor: 'rgba(5, 81, 130, 1)', fontSize: "10px", color: "white", disableSorting: true },
        ] :
        [
            { id: '', label: 'AÑO', width: '10px', textAlign: "center", backgroundColor: 'rgba(5, 81, 130, 1)', fontSize: "10px", color: "white", disableSorting: true },
            { id: '', label: 'MES', width: '80px', textAlign: "center", backgroundColor: 'rgba(5, 81, 130, 1)', fontSize: "10px", color: "white", disableSorting: true },
            { id: '', label: 'DESCRIPCIÓN', width: '200px', textAlign: "center", backgroundColor: 'rgba(5, 81, 130, 1)', fontSize: "10px", color: "white", disableSorting: true },
            { id: '', label: 'MONTO', width: '80px', textAlign: "center", backgroundColor: 'rgba(5, 81, 130, 1)', fontSize: "10px", color: "white", disableSorting: true },
        ]

    const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } = useTable(deuda, headCells, filterFn);

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            setSelected(deuda);
            return;
        } else {
            setSelected([]);
        }
    };

    const handleClick = (row) => {
        const selectedIndex = selected.indexOf(row);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, row);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1)
            );
        }

        setSelected(newSelected);
    };

    const seleccionarFila = (index, item) => (event) => {
        setItemSelect(index); // Actualiza el estado con el índice de la fila seleccionada
        setActivo(false);

        if (props.tipo === "publicidad") {
            setDudaP(item); // Guarda la deuda seleccionada para publicidad
        } else {
            setDeudaL(item); // Guarda la deuda seleccionada para licores
        }
    };

    const handleSearch = (e) => {
        let target = e.target;

        setFilterFn({
            fn: (items) => {
                if (target.value === "") {
                    return items;
                } else {
                    return items.filter((x) => {
                        if (
                            x.anio
                                .toString()
                                .toLowerCase()
                                .includes(target.value.toLowerCase()) ||
                                x.mes
                                    .toString()
                                    .toLowerCase()
                                    .includes(target.value.toLowerCase()) ||
                                x.descripcion
                                    .toString()
                                    .toLowerCase()
                                    .includes(target.value.toLowerCase()) ||
                                formatMoneda(x.monto.toString().replace('.', ','), ',', '.', 2).includes(target.value) ||
                                props.tipo === "publicidad" ?
                                x.ubicacion.toString().toLowerCase().includes(target.value.toLowerCase())
                                : ''

                        ) {
                            return x;
                        }
                    });
                }
            },
        });
    };

    const blanquear = () => {
        setOperacion(0);
        setDeuda([]);
        setHistorico([]);
        setContribuyente({
            idcontribuyente: "",
            nombre: "",
            ritm: "",
            rif: "",
            direccion: "",
            status: "",
        });
    };


    const SelectDeuda = () => {
        setActivate(true);
        let tab = "";
        let tipod = "";
        let nomtab = "";
        let idcom = "";
        let endpoint = '';
        switch (props.tipo) {
            case "publicidad":
                nomtab = "publicidad";
                idcom = "idcomercio";
                //endpoint = `${op.conexion}/api/publicidad/consultadeuda?nomtab=${nomtab}&nomid=${idcom}&id=${data.idcomercio}`;
                endpoint = `${op.conexion}/api/publicidad/consultadeuda?nomtab=${nomtab}&nomid=${idcom}&id=${props.contribuyente.idcontribuyente}`;
                break;
            case "licores":
                nomtab = "licores";
                idcom = "idcomercio";
                //endpoint = `${op.conexion}/api/inmueble/deudainmueble?idinmueble=${props.contribuyente.idcontribuyente}&fecha=${fechaSistema}&espiritu=${espiritu}`;
                endpoint = `${op.conexion}/api/licores/deudalicores?nomtab=${nomtab}&nomid=${idcom}&id=${props.contribuyente.idcontribuyente} `;
                break;
            default:
                break;
        }



        axios
            .get(endpoint, {
                headers: {
                    "x-access-token": `${token}`,
                    app: "admin"
                },
            })
            .then(function (response) {
                if (response.status == 200) {
                    if (response.data.length > 0) {
                        var deu = [];
                        var his = [];
                        let totrec = parseFloat(0.0);
                        let totinte = parseFloat(0.0);
                        let totimpu = parseFloat(0.0);
                        let totmulta = parseFloat(0.0);
                        if (props.tipo === "publicidad") {
                            var mes;
                            var mas = 0.0;
                            var desc = 0.0;
                            var total = 0.0;
                            for (var i = 0; i < response.data.length; i++) {
                                var mm =
                                    response.data[i].fechainscripcion === null
                                        ? 0
                                        : parseInt(
                                            moment.utc(response.data[i].fechainscripcion)
                                                .format("YYYY-MM-DD")
                                                .substring(5, 7)
                                        );
                                switch (mm) {
                                    case 1:
                                        mes = "ENERO";
                                        break;
                                    case 2:
                                        mes = "FEBRERO";
                                        break;
                                    case 3:
                                        mes = "MARZO";
                                        break;
                                    case 4:
                                        mes = "ABRIL";
                                        break;
                                    case 5:
                                        mes = "MAYO";
                                        break;
                                    case 6:
                                        mes = "JUNIO";
                                        break;
                                    case 7:
                                        mes = "JULIO";
                                        break;
                                    case 8:
                                        mes = "AGOSTO";
                                        break;
                                    case 9:
                                        mes = "SEPTIEMBRE";
                                        break;
                                    case 10:
                                        mes = "OCTUBRE";
                                        break;
                                    case 11:
                                        mes = "NOVIEMBRE";
                                        break;
                                    case 12:
                                        mes = "DICIEMBRE";
                                        break;
                                }
                                if (!response.data[i].cancelada) {
                                    totimpu = totimpu + (parseFloat(response.data[i].monto) * parseFloat(props.factorcambio));
                                    mas = parseFloat(response.data[i].monto);
                                    desc = desc + mas;
                                    total = formatMoneda(
                                        desc.toString().replace(".", ","),
                                        ",",
                                        ".",
                                        2
                                    );

                                    deu.push({
                                        idpublicidad: response.data[i].idpublicidad,
                                        idcomercio: response.data[i].idcomercio,
                                        idtipopublicidad: response.data[i].idtipopublicidad,
                                        ancho: response.data[i].ancho,
                                        alto: response.data[i].alto,
                                        cantidad: response.data[i].cantidad,
                                        monto: response.data[i].monto * props.factorcambio,
                                        anio: response.data[i].anio,
                                        cancelada: response.data[i].cancelada,
                                        fechainscripcion: response.data[i].fechainscripcion,
                                        ubicacion: response.data[i].ubicacion,
                                        fechapago: response.data[i].fechapago,
                                        numerorecibo: response.data[i].numerorecibo,
                                        reccroquisubi: response.data[i].reccroquisubi,
                                        recplanoestructura: response.data[i].recplanoestructura,
                                        recautpropieinmue: response.data[i].recautpropieinmue,
                                        recautinsvialreg: response.data[i].recautinsvialreg,
                                        recusoconfddu: response.data[i].recusoconfddu,
                                        descripcion: response.data[i].descripcion,
                                        codigoordenanza: response.data[i].codigoordenanza,
                                        mes: mes,
                                    });
                                } else {
                                    total = mas;
                                    his.push({
                                        idpublicidad: response.data[i].idpublicidad,
                                        idcomercio: response.data[i].idcomercio,
                                        idtipopublicidad: response.data[i].idtipopublicidad,
                                        ancho: response.data[i].ancho,
                                        alto: response.data[i].alto,
                                        cantidad: response.data[i].cantidad,
                                        monto: response.data[i].monto,
                                        anio: response.data[i].anio,
                                        cancelada: response.data[i].cancelada,
                                        fechainscripcion: response.data[i].fechainscripcion,
                                        ubicacion: response.data[i].ubicacion,
                                        fechapago: response.data[i].fechapago,
                                        numerorecibo: response.data[i].numerorecibo,
                                        reccroquisubi: response.data[i].reccroquisubi,
                                        recplanoestructura: response.data[i].recplanoestructura,
                                        recautpropieinmue: response.data[i].recautpropieinmue,
                                        recautinsvialreg: response.data[i].recautinsvialreg,
                                        recusoconfddu: response.data[i].recusoconfddu,
                                        descripcion: response.data[i].descripcion,
                                        codigoordenanza: response.data[i].codigoordenanza,
                                        mes: mes,
                                    });
                                }
                            }
                        } else {
                            var mm =
                                response.data.fechainscripcion === null
                                    ? 0
                                    : parseInt(
                                        moment.utc(response.data.fechainscripcion)
                                            .format("YYYY-MM-DD")
                                            .substring(5, 7)
                                    );
                            var mon = 0.0;
                            var n;
                            var mes;

                            for (let i = 0; i < response.data.length; i++) {
                                mon = response.data[i].monto;
                                switch (mm) {
                                    case 1:
                                        mes = "ENERO";
                                        break;
                                    case 2:
                                        mes = "FEBRERO";
                                        break;
                                    case 3:
                                        mes = "MARZO";
                                        break;
                                    case 4:
                                        mes = "ABRIL";
                                        break;
                                    case 5:
                                        mes = "MAYO";
                                        break;
                                    case 6:
                                        mes = "JUNIO";
                                        break;
                                    case 7:
                                        mes = "JULIO";
                                        break;
                                    case 8:
                                        mes = "AGOSTO";
                                        break;
                                    case 9:
                                        mes = "SEPTIEMBRE";
                                        break;
                                    case 10:
                                        mes = "OCTUBRE";
                                        break;
                                    case 11:
                                        mes = "NOVIEMBRE";
                                        break;
                                    case 12:
                                        mes = "DICIEMBRE";
                                        break;
                                }
                                if (!response.data[i].cancelada) {
                                    totimpu = totimpu + (parseFloat(response.data[i].monto) * parseFloat(props.factorcambio));
                                    deu.push({
                                        idlicores: response.data[i].idlicores,
                                        idcomercio: response.data[i].idcomercio,
                                        idtipotasa: response.data[i].idtipotasa,
                                        anio: response.data[i].anio,
                                        mes: mes,
                                        descripcion: response.data[i].descripcion,
                                        cantidad: response.data[i].cantidad,
                                        monto: response.data[i].monto * props.factorcambio,
                                        fechainscripcion: response.data[i].fechainscripcion,
                                        codigoordenanza: response.data[i].codigo,
                                    });
                                } else {
                                    n = mon;
                                    his.push({
                                        idlicores: response.data[i].idlicores,
                                        idcomercio: response.data[i].idcomercio,
                                        idtipotasa: response.data[i].idtipotasa,
                                        anio: response.data[i].anio,
                                        mes: mes,
                                        descripcion: response.data[i].descripcion,
                                        cantidad: response.data[i].cantidad,
                                        monto: n,
                                        numereci:
                                            response.data[i].numerorecibo !== null
                                                ? response.data[i].numerorecibo
                                                : " ",
                                        fechapago:
                                            response.data[i].fechapago !== null
                                                ? moment.utc(response.data[i].fechapago).format("YYYY/MM/DD")
                                                : "",
                                        fechainscripcion: response.data[i].fechainscripcion,
                                        codigoordenanza: response.data[i].codigo,
                                    });
                                }
                            }
                        }
                        setImpuesto(totimpu);
                        setRecargo(totrec);
                        setInteres(totinte);
                        setTotDeuda(totimpu)
                        setDeuda(deu);
                        setHistorico(his);
                        //setTotal(total);
                        //setMostrar5(true);
                    } else {
                        //setMostrar5(true);
                    }
                }
                setActivate(false);
            })
            .catch(function (error) {
                setMensaje({
                    mostrar: true,
                    titulo: "Error",
                    texto: error.response.data.message,
                    icono: "error",
                });
                setActivate(false);
            })
            .finally(() => setActivate(false));
    };

    const cancelar = () => {
        blanquear();
        props.onHide();
    };

    useEffect(() => {
        seleccionarConfiguracion();
    }, []);

    const gestionar = (n) => {


        setOperacion(n);
        if (props.tipo === "publicidad") {
            if (deudaP && parseInt(deudaP.idpublicidad) > 0) {
                setShow(true)
            }


        } else if (props.tipo === "licores") {
            if (deudaL && parseInt(deudaL.idlicores) > 0) {
                setShow2(true)
            }

        }
    };

    const seleccionarConfiguracion = () => {
        let campos = "*";
        let nomtab = "";
        let orden = "1";
        switch (props.tipo) {
            case "publicidad":
                nomtab = "configpublicidad";
                break;
            case "licores":
                nomtab = "configlicores";
                break;
            case "vehiculo":
                nomtab = "configvehiculo";
                break;
            case "rentas":
                nomtab = "configrentas";
                break;
            case "apuestas":
                nomtab = "configapuesta";
                break;
        }
        let endpoint = `${op.conexion}/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
        setActivate(true);
        axios
            .get(endpoint, {
                headers: {
                    "x-access-token": `${token}`,
                    "Content-Type": "application/json",
                },
            })
            .then(function (response) {
                if (response.status == 200) {
                    setConfig(response.data[0]);
                }
            })
            .catch(function (error) {
                setMensaje({
                    mostrar: true,
                    titulo: "ERROR",
                    texto: error.response.data.message,
                    icono: "error",
                });
                setActivate(false);
            });
    };

    const imprimirDeuda = (event) => {
        event.preventDefault();
        let fechasistema = JSON.parse(localStorage.getItem('fechasistema'));
        let espiritu = JSON.parse(localStorage.getItem('espiritu'));
        var reporte = '';
        var id = contribuyente.idcontribuyente;
        var valpetro = props.factorCambio;
        var radioBolivares = 1;
        if (props.tipo === "publicidad") {
            reporte = 'EdoCtaCorto2Public';
            var sql = "B.IdCOMERCIO=" + id;
            reporte = 'EdoCtaCorto2Public';
            window.open(op.reportes + "/propagandapublicidad?" + "reporte=" + reporte + "&sql=" + sql + "&valpetro=" + valpetro + "&radioBolivares=" + radioBolivares, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
        } else if (props.tipo === "licores") {
            reporte = 'EdoCtaRentaLic';
            var idcomercio = "CONTRIB.CODIGO=" + id;
            window.open(op.reportes + "/rentaslicores?" + "reporte=" + reporte + "&sql=" + idcomercio + "&valorpetro=" + props.petro + "&bolivares=" + radioBolivares, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
        }
    }

    const imprimirRelacionPago = () => (event) => {
        event.preventDefault();
        var reporte = '';
        var id = contribuyente.idcontribuyente;
        if (props.tipo === "publicidad") {
            reporte = "Planillacontricomercio";
            window.open(op.reportes + "/inmueblesurbanos?" + "reporte=" + reporte + "&id=" + id + "&tipo=(16)", "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
        } else if (props.tipo === "licores") {
            reporte = "Planillacontricomercio";
            window.open(op.reportes + "/inmueblesurbanos?" + "reporte=" + reporte + "&id=" + id + "&tipo=(16)", "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
        }
        

    };
    return (
        <Modal
            {...props}
            size="xl"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
            backdrop="static"
            keyboard={false}
            onShow={() => {
                SelectDeuda();
                setContribuyente(props.contribuyente);
            }}
        >
            <Modal.Header className="col-12 m-0 px-4 py-2 d-flex align-items-center justify-content-between azulGradiant rounded-top text-light">
                <h3 className="my-auto">Gestionar de Deuda</h3>
                <a type='button'
                    className="fw-bold text-light fs-6"
                    onClick={cancelar}
                >
                    Salir <i className="fa fa-times ms-2"></i>
                </a>
            </Modal.Header>
            <Modal.Body>
                <div className="container-fluid rounded">
                    <div className="tab-content" id="ex-with-icons-content">
                        <div
                            className="tab-pane fade show active"
                            id="tab-1"
                            role="tabpanel"
                            aria-labelledby="ex-with-icons-tab-1"
                        >
                            <fieldset className="row border-azul rounded mx-auto col-sm-12">
                                <legend className="float-none m-0 w-auto">
                                    Datos Generales
                                </legend>
                                <div class="input-group input-group-sm mb-1 px-0 col-md-2">
                                    <span class="input-group-text border-0 bg-transparent" id="inputGroup-sizing-sm">Código:</span>
                                    <input type="text" value={contribuyente ? contribuyente.idcontribuyente : ""} disabled class="form-control bg-transparent border-0" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                                </div>

                                <div class="input-group input-group-sm mb-1 px-0 col-md-2">
                                    <span class="input-group-text border-0 bg-transparent" id="inputGroup-sizing-sm">N° de Ritm:</span>
                                    <input type="text" value={contribuyente ? contribuyente.ritm : ""} disabled class="form-control bg-transparent border-0" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                                </div>
                                <div class="input-group input-group-sm mb-1 px-0 col-md-6"></div>
                                <div class="input-group input-group-sm mb-1 px-0 col-md-2">
                                    <span class="input-group-text border-0 bg-transparent" id="inputGroup-sizing-sm">Status:</span>
                                    <input type="text" value={contribuyente ? contribuyente.status : ""} disabled class="text-rightform-control text-uppercasebg-transparent border-0" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                                </div>

                                <div class="input-group input-group-sm mb-1 px-0 col-md-9">
                                    <span class="input-group-text border-0 bg-transparent" id="inputGroup-sizing-sm">Nombre:</span>
                                    <input type="text" value={contribuyente ? contribuyente.nombre : ""} disabled class="form-control bg-transparent border-0" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                                </div>

                                <div class="input-group input-group-sm mb-1 px-0 col-md-3">
                                    <span class="input-group-text border-0 bg-transparent" id="inputGroup-sizing-sm">Cédula / Rif:</span>
                                    <input type="text" value={contribuyente ? contribuyente.rif : ""} disabled class="form-control bg-transparent border-0 text-right" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                                </div>
                                <div class="input-group input-group-sm mb-1 px-0 col-md-12">
                                    <span class="input-group-text border-0 bg-transparent" id="inputGroup-sizing-sm">Dirección:</span>
                                    <input type="text" value={contribuyente ? contribuyente.direccion : ""} disabled class="form-control bg-transparent border-0" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                                </div>

                            </fieldset>
                            <ul className="nav mb-2" id="ex-with-icons" role="tablist">
                                <li className="nav-item" role="presentation">
                                    <a
                                        className="nav-link text-light rounded"
                                        style={{ backgroundColor: "#F93154" }}
                                        id="deuda-tab"
                                        data-bs-toggle="tab" // Aquí el cambio
                                        href="#deuda"
                                        role="tab"
                                        aria-controls="deuda"
                                        aria-selected="true"
                                    >
                                        <i className="fas fa-money-check fa-fw me-2" />
                                        Deudas
                                    </a>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <a
                                        className="nav-link text-dark rounded"
                                        style={{ backgroundColor: "#25d366" }}
                                        id="historico-tab"
                                        data-bs-toggle="tab" // Aquí el cambio
                                        href="#historico"
                                        role="tab"
                                        aria-controls="historico"
                                        aria-selected="false"
                                    >
                                        <i className="fas fa-book-open fa-fw me-2" />
                                        Historico de Pagos
                                    </a>
                                </li>
                                {/*<button
                                    className="btn btn-sm btn-info rounded-pill col-md-2 ml-auto my-2"
                                // onClick={imprimirRelacionPago("Planillacontricomercio")}
                                >
                                    <i className="fas fa-print"> Pagos Web</i>{" "}
                                </button>*/}
                            </ul>
                            <div className="tab-content" id="ex-with-icons-content">
                                <div className="tab-pane fade show active" id="deuda" role="tabpanel" aria-labelledby="deuda-tab">

                                    <div className="row col-md-12">

                                        <div className="col-md-9 row px-0" style={{ margin: "auto" }}>
                                            <button style={{ height: '30px', width: '30px' }} onClick={imprimirDeuda} className="btn btn-sm btn-primary ml-auto rounded-circle mb-2"><i className="fas fa-print"></i> </button>

                                            <TblContainer>
                                                <TblHead />
                                                <tbody>
                                                    {deuda && recordsAfterPagingAndSorting().map((item, index) => {
                                                        return (
                                                            <tr
                                                                key={index}
                                                                style={{
                                                                    padding: "0",
                                                                    cursor: "pointer",
                                                                    backgroundColor: itemSelect === index ? "lightskyblue" : "white", // Estilo condicional
                                                                }}
                                                                onClick={seleccionarFila(index, item)} // Selecciona la fila al hacer clic
                                                            >
                                                                <td style={{ fontSize: "10px", textAlign: "left" }}>{item.anio}</td>
                                                                <td style={{ fontSize: "10px", textAlign: "left" }}>{item.mes}</td>
                                                                <td style={{ fontSize: "10px", textAlign: "center" }}>{item.descripcion}</td>
                                                                <td style={{ fontSize: "10px", textAlign: "right" }}>
                                                                    {formatMoneda(item.monto.toString().replace(".", ","), ",", ".", 2)}
                                                                </td>
                                                                {props.tipo === "publicidad" ? (
                                                                    <td style={{ fontSize: "10px", textAlign: "center" }}>{item.ubicacion}</td>
                                                                ) : (
                                                                    ""
                                                                )}
                                                            </tr>
                                                        );
                                                    })}
                                                </tbody>
                                            </TblContainer>
                                            <TblPagination />
                                        </div>
                                        <div className='col-md-3 row'>

                                            <div class="input-group input-group-sm mb-0 col-md-12">
                                                <span class="input-group-text bg-transparent border-0" id="inputGroup-sizing-sm">Deuda:</span>
                                                <input type="text" value={impuesto ? formatMoneda(impuesto.toString().replace(",", "").replace(".", ","), ",", ".", 2) : "0,00"} disabled class="form-control text-right bg-transparent border-0" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                                            </div>

                                            <div class="input-group input-group-sm mb-0 col-md-12">
                                                <span class="input-group-text bg-transparent border-0" id="inputGroup-sizing-sm">Intereses de Mora:</span>
                                                <input type="text" value={interes ? formatMoneda(interes.toString().replace(",", "").replace(".", ","), ",", ".", 2) : "0,00"} disabled class="form-control text-right bg-transparent border-0" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                                            </div>

                                            <div class="input-group input-group-sm mb-0 col-md-12">
                                                <span class="input-group-text bg-transparent border-0" id="inputGroup-sizing-sm">Recargo por Mora:</span>
                                                <input type="text" value={recargo ? formatMoneda(recargo.toString().replace(",", "").replace(".", ","), ",", ".", 2) : "0,00"} disabled class="form-control text-right bg-transparent border-0" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                                            </div>

                                            {/*<div class="input-group input-group-sm mb-0 col-md-12">
                                                <span class="input-group-text bg-transparent border-0" id="inputGroup-sizing-sm">Multa:</span>
                                                <input type="text" value={multa} disabled class="form-control text-right bg-transparent border-0" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                                            </div>*/}

                                            <div class="input-group input-group-sm mb-0 col-md-12">
                                                <span class="input-group-text bg-transparent border-0" id="inputGroup-sizing-sm">Total de la Deuda:</span>
                                                <input type="text" value={totDeuda ? formatMoneda(totDeuda.toString().replace(",", "").replace(".", ","), ",", ".", 2) : "0,00"} disabled class="form-control text-right bg-transparent border-0" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div className="tab-pane fade" id="historico" role="tabpanel" aria-labelledby="historico-tab">
                                    {props.tipo === "licores" ?
                                        <TablaHistoricoLicores tabHis={historico} />
                                        : props.tipo === "publicidad" ?
                                            <Tablahtpp tabhistoy={historico} idcomercio={contribuyente.idcontribuyente} />
                                            : ""}

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <div className="row col-md-12">

                    <button
                        type="button"
                        style={{ maxWidth: 150, marginLeft: 3, marginRight: 3 }}
                        onClick={() => gestionar(3)}
                        className="col-md-3 fw-bold btn btn-warning btn-sm rounded-pill"
                    >
                        <i className="fas fa-sync"></i> Actualizar
                    </button>

                </div>
            </Modal.Footer>
            <Dimmer active={activate} />
            <Mensaje
                mensaje={mensaje}
                onHide={() => {
                    setMensaje({
                        mostrar: false,
                        titulo: "",
                        texto: "",
                        icono: "",
                    });
                }}
            />
            <ModalAgregarDeudaPublicidad
                show={show}
                operacion={operacion}
                onHide={() => setShow(false)}
                onHideAcepta={() => {
                    setShow(false),
                        setOperacion(0),
                        SelectDeuda()
                }}
                deuda={deudaP}
                /*  agente={agente}
             */
                factorcambio={props.factorcambio}
                tipo={props.tipo}
                config={config}
            />
            <ModalAgregarDeudaLicores
                show={show2}
                operacion={operacion}
                onHide={() => setShow2(false)}
                onHideAcepta={() => {
                    setShow2(false),
                        setOperacion(0),
                        SelectDeuda()
                }}
                deuda={deudaL}
                /* agente={agente}
            */
                factorcambio={props.factorcambio}
                tipo={props.tipo}
                config={config}
            />
        </Modal>
    );
};
